/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as dasboardRouteRouteImport } from './routes/(dasboard)/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as dasboardSettingsRouteImport } from './routes/(dasboard)/settings'
import { Route as dasboardProfileRouteImport } from './routes/(dasboard)/profile'
import { Route as dasboardPosRouteImport } from './routes/(dasboard)/pos'
import { Route as dasboardDashboardRouteImport } from './routes/(dasboard)/dashboard'
import { Route as dasboardAuditLogsRouteImport } from './routes/(dasboard)/audit-logs'
import { Route as dasboardInventoryIndexRouteImport } from './routes/(dasboard)/inventory/index'
import { Route as dasboardFinanceIndexRouteImport } from './routes/(dasboard)/finance/index'
import { Route as dasboardEmployeesIndexRouteImport } from './routes/(dasboard)/employees/index'
import { Route as dasboardCustomersIndexRouteImport } from './routes/(dasboard)/customers/index'
import { Route as onboardingSetupSelectShopRouteImport } from './routes/(onboarding)/setup/select-shop'
import { Route as onboardingSetupCreateShopRouteImport } from './routes/(onboarding)/setup/create-shop'
import { Route as onboardingSetupCreateBusinessRouteImport } from './routes/(onboarding)/setup/create-business'
import { Route as onboardingAuthVerifySuccessRouteImport } from './routes/(onboarding)/auth/verify-success'
import { Route as onboardingAuthVerifyFailedRouteImport } from './routes/(onboarding)/auth/verify-failed'
import { Route as onboardingAuthVerifyAccountRouteImport } from './routes/(onboarding)/auth/verify-account'
import { Route as onboardingAuthResetPasswordRouteImport } from './routes/(onboarding)/auth/reset-password'
import { Route as onboardingAuthRegisterRouteImport } from './routes/(onboarding)/auth/register'
import { Route as onboardingAuthPasswordForgotRouteImport } from './routes/(onboarding)/auth/password-forgot'
import { Route as onboardingAuthLogoutRouteImport } from './routes/(onboarding)/auth/logout'
import { Route as onboardingAuthLoginRouteImport } from './routes/(onboarding)/auth/login'
import { Route as dasboardProductsTypesRouteImport } from './routes/(dasboard)/products/types'
import { Route as dasboardProductsSuppliersRouteImport } from './routes/(dasboard)/products/suppliers'
import { Route as dasboardProductsCategoriesRouteImport } from './routes/(dasboard)/products/categories'
import { Route as dasboardInventoryWarehousesRouteImport } from './routes/(dasboard)/inventory/warehouses'
import { Route as dasboardFinanceTransfersRouteImport } from './routes/(dasboard)/finance/transfers'
import { Route as dasboardFinanceIncomesRouteImport } from './routes/(dasboard)/finance/incomes'
import { Route as dasboardFinanceIncomeCategoriesRouteImport } from './routes/(dasboard)/finance/income-categories'
import { Route as dasboardFinanceExpensesRouteImport } from './routes/(dasboard)/finance/expenses'
import { Route as dasboardFinanceExpenseCategoriesRouteImport } from './routes/(dasboard)/finance/expense-categories'
import { Route as dasboardFinanceCategoriesRouteImport } from './routes/(dasboard)/finance/categories'
import { Route as dasboardEmployeesCreateRouteImport } from './routes/(dasboard)/employees/create'
import { Route as dasboardCustomersIdRouteImport } from './routes/(dasboard)/customers/$id'
import { Route as dasboardProductsServicesIndexRouteImport } from './routes/(dasboard)/products/services/index'
import { Route as dasboardProductsProductsIndexRouteImport } from './routes/(dasboard)/products/products/index'
import { Route as dasboardOrdersReturnsIndexRouteImport } from './routes/(dasboard)/orders/returns/index'
import { Route as dasboardOrdersOrdersIndexRouteImport } from './routes/(dasboard)/orders/orders/index'
import { Route as dasboardInventorySupplyReturnsIndexRouteImport } from './routes/(dasboard)/inventory/supply-returns/index'
import { Route as dasboardInventoryStockTransfersIndexRouteImport } from './routes/(dasboard)/inventory/stock-transfers/index'
import { Route as dasboardInventoryStockBatchsIndexRouteImport } from './routes/(dasboard)/inventory/stock-batchs/index'
import { Route as dasboardFinanceAccountsIndexRouteImport } from './routes/(dasboard)/finance/accounts/index'
import { Route as dasboardProductsServicesCreateRouteImport } from './routes/(dasboard)/products/services/create'
import { Route as dasboardProductsServicesIdRouteImport } from './routes/(dasboard)/products/services/$id'
import { Route as dasboardProductsProductsCreateRouteImport } from './routes/(dasboard)/products/products/create'
import { Route as dasboardProductsProductsIdRouteImport } from './routes/(dasboard)/products/products/$id'
import { Route as dasboardOrdersReturnsCreateRouteImport } from './routes/(dasboard)/orders/returns/create'
import { Route as dasboardOrdersReturnsIdRouteImport } from './routes/(dasboard)/orders/returns/$id'
import { Route as dasboardOrdersOrdersCreateRouteImport } from './routes/(dasboard)/orders/orders/create'
import { Route as dasboardOrdersOrdersIdRouteImport } from './routes/(dasboard)/orders/orders/$id'
import { Route as dasboardInventorySupplyReturnsCreateRouteImport } from './routes/(dasboard)/inventory/supply-returns/create'
import { Route as dasboardInventorySupplyReturnsIdRouteImport } from './routes/(dasboard)/inventory/supply-returns/$id'
import { Route as dasboardInventoryStockTransfersCreateRouteImport } from './routes/(dasboard)/inventory/stock-transfers/create'
import { Route as dasboardInventoryStockBatchsCreateRouteImport } from './routes/(dasboard)/inventory/stock-batchs/create'
import { Route as dasboardFinanceDebtsSuppliersDebtsRouteImport } from './routes/(dasboard)/finance/debts/suppliers-debts'
import { Route as dasboardFinanceDebtsSuppliersCreditsRouteImport } from './routes/(dasboard)/finance/debts/suppliers-credits'
import { Route as dasboardFinanceDebtsCustomersDebtsRouteImport } from './routes/(dasboard)/finance/debts/customers-debts'
import { Route as dasboardFinanceAccountsIdRouteImport } from './routes/(dasboard)/finance/accounts/$id'
import { Route as dasboardEmployeesIdViewRouteImport } from './routes/(dasboard)/employees/$id.view'
import { Route as dasboardEmployeesIdEditRouteImport } from './routes/(dasboard)/employees/$id.edit'
import { Route as dasboardInventoryStockBatchsIdQuantityTransferOutRouteImport } from './routes/(dasboard)/inventory/stock-batchs/$id/quantity-transfer-out'
import { Route as dasboardInventoryStockBatchsIdQuantityTransferInRouteImport } from './routes/(dasboard)/inventory/stock-batchs/$id/quantity-transfer-in'
import { Route as dasboardInventoryStockBatchsIdQuantitySupplyReturnRouteImport } from './routes/(dasboard)/inventory/stock-batchs/$id/quantity-supply-return'
import { Route as dasboardInventoryStockBatchsIdQuantitySoldRouteImport } from './routes/(dasboard)/inventory/stock-batchs/$id/quantity-sold'
import { Route as dasboardInventoryStockBatchsIdQuantitySaleReturnRouteImport } from './routes/(dasboard)/inventory/stock-batchs/$id/quantity-sale-return'
import { Route as dasboardInventoryStockBatchsIdQuantityAdjustedRouteImport } from './routes/(dasboard)/inventory/stock-batchs/$id/quantity-adjusted'
import { Route as dasboardInventoryStockBatchsIdPriceChangesRouteImport } from './routes/(dasboard)/inventory/stock-batchs/$id/price-changes'

const dasboardRouteRoute = dasboardRouteRouteImport.update({
  id: '/(dasboard)',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const dasboardSettingsRoute = dasboardSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => dasboardRouteRoute,
} as any)
const dasboardProfileRoute = dasboardProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => dasboardRouteRoute,
} as any)
const dasboardPosRoute = dasboardPosRouteImport.update({
  id: '/pos',
  path: '/pos',
  getParentRoute: () => dasboardRouteRoute,
} as any)
const dasboardDashboardRoute = dasboardDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => dasboardRouteRoute,
} as any)
const dasboardAuditLogsRoute = dasboardAuditLogsRouteImport.update({
  id: '/audit-logs',
  path: '/audit-logs',
  getParentRoute: () => dasboardRouteRoute,
} as any)
const dasboardInventoryIndexRoute = dasboardInventoryIndexRouteImport.update({
  id: '/inventory/',
  path: '/inventory/',
  getParentRoute: () => dasboardRouteRoute,
} as any)
const dasboardFinanceIndexRoute = dasboardFinanceIndexRouteImport.update({
  id: '/finance/',
  path: '/finance/',
  getParentRoute: () => dasboardRouteRoute,
} as any)
const dasboardEmployeesIndexRoute = dasboardEmployeesIndexRouteImport.update({
  id: '/employees/',
  path: '/employees/',
  getParentRoute: () => dasboardRouteRoute,
} as any)
const dasboardCustomersIndexRoute = dasboardCustomersIndexRouteImport.update({
  id: '/customers/',
  path: '/customers/',
  getParentRoute: () => dasboardRouteRoute,
} as any)
const onboardingSetupSelectShopRoute =
  onboardingSetupSelectShopRouteImport.update({
    id: '/(onboarding)/setup/select-shop',
    path: '/setup/select-shop',
    getParentRoute: () => rootRouteImport,
  } as any)
const onboardingSetupCreateShopRoute =
  onboardingSetupCreateShopRouteImport.update({
    id: '/(onboarding)/setup/create-shop',
    path: '/setup/create-shop',
    getParentRoute: () => rootRouteImport,
  } as any)
const onboardingSetupCreateBusinessRoute =
  onboardingSetupCreateBusinessRouteImport.update({
    id: '/(onboarding)/setup/create-business',
    path: '/setup/create-business',
    getParentRoute: () => rootRouteImport,
  } as any)
const onboardingAuthVerifySuccessRoute =
  onboardingAuthVerifySuccessRouteImport.update({
    id: '/(onboarding)/auth/verify-success',
    path: '/auth/verify-success',
    getParentRoute: () => rootRouteImport,
  } as any)
const onboardingAuthVerifyFailedRoute =
  onboardingAuthVerifyFailedRouteImport.update({
    id: '/(onboarding)/auth/verify-failed',
    path: '/auth/verify-failed',
    getParentRoute: () => rootRouteImport,
  } as any)
const onboardingAuthVerifyAccountRoute =
  onboardingAuthVerifyAccountRouteImport.update({
    id: '/(onboarding)/auth/verify-account',
    path: '/auth/verify-account',
    getParentRoute: () => rootRouteImport,
  } as any)
const onboardingAuthResetPasswordRoute =
  onboardingAuthResetPasswordRouteImport.update({
    id: '/(onboarding)/auth/reset-password',
    path: '/auth/reset-password',
    getParentRoute: () => rootRouteImport,
  } as any)
const onboardingAuthRegisterRoute = onboardingAuthRegisterRouteImport.update({
  id: '/(onboarding)/auth/register',
  path: '/auth/register',
  getParentRoute: () => rootRouteImport,
} as any)
const onboardingAuthPasswordForgotRoute =
  onboardingAuthPasswordForgotRouteImport.update({
    id: '/(onboarding)/auth/password-forgot',
    path: '/auth/password-forgot',
    getParentRoute: () => rootRouteImport,
  } as any)
const onboardingAuthLogoutRoute = onboardingAuthLogoutRouteImport.update({
  id: '/(onboarding)/auth/logout',
  path: '/auth/logout',
  getParentRoute: () => rootRouteImport,
} as any)
const onboardingAuthLoginRoute = onboardingAuthLoginRouteImport.update({
  id: '/(onboarding)/auth/login',
  path: '/auth/login',
  getParentRoute: () => rootRouteImport,
} as any)
const dasboardProductsTypesRoute = dasboardProductsTypesRouteImport.update({
  id: '/products/types',
  path: '/products/types',
  getParentRoute: () => dasboardRouteRoute,
} as any)
const dasboardProductsSuppliersRoute =
  dasboardProductsSuppliersRouteImport.update({
    id: '/products/suppliers',
    path: '/products/suppliers',
    getParentRoute: () => dasboardRouteRoute,
  } as any)
const dasboardProductsCategoriesRoute =
  dasboardProductsCategoriesRouteImport.update({
    id: '/products/categories',
    path: '/products/categories',
    getParentRoute: () => dasboardRouteRoute,
  } as any)
const dasboardInventoryWarehousesRoute =
  dasboardInventoryWarehousesRouteImport.update({
    id: '/inventory/warehouses',
    path: '/inventory/warehouses',
    getParentRoute: () => dasboardRouteRoute,
  } as any)
const dasboardFinanceTransfersRoute =
  dasboardFinanceTransfersRouteImport.update({
    id: '/finance/transfers',
    path: '/finance/transfers',
    getParentRoute: () => dasboardRouteRoute,
  } as any)
const dasboardFinanceIncomesRoute = dasboardFinanceIncomesRouteImport.update({
  id: '/finance/incomes',
  path: '/finance/incomes',
  getParentRoute: () => dasboardRouteRoute,
} as any)
const dasboardFinanceIncomeCategoriesRoute =
  dasboardFinanceIncomeCategoriesRouteImport.update({
    id: '/finance/income-categories',
    path: '/finance/income-categories',
    getParentRoute: () => dasboardRouteRoute,
  } as any)
const dasboardFinanceExpensesRoute = dasboardFinanceExpensesRouteImport.update({
  id: '/finance/expenses',
  path: '/finance/expenses',
  getParentRoute: () => dasboardRouteRoute,
} as any)
const dasboardFinanceExpenseCategoriesRoute =
  dasboardFinanceExpenseCategoriesRouteImport.update({
    id: '/finance/expense-categories',
    path: '/finance/expense-categories',
    getParentRoute: () => dasboardRouteRoute,
  } as any)
const dasboardFinanceCategoriesRoute =
  dasboardFinanceCategoriesRouteImport.update({
    id: '/finance/categories',
    path: '/finance/categories',
    getParentRoute: () => dasboardRouteRoute,
  } as any)
const dasboardEmployeesCreateRoute = dasboardEmployeesCreateRouteImport.update({
  id: '/employees/create',
  path: '/employees/create',
  getParentRoute: () => dasboardRouteRoute,
} as any)
const dasboardCustomersIdRoute = dasboardCustomersIdRouteImport.update({
  id: '/customers/$id',
  path: '/customers/$id',
  getParentRoute: () => dasboardRouteRoute,
} as any)
const dasboardProductsServicesIndexRoute =
  dasboardProductsServicesIndexRouteImport.update({
    id: '/products/services/',
    path: '/products/services/',
    getParentRoute: () => dasboardRouteRoute,
  } as any)
const dasboardProductsProductsIndexRoute =
  dasboardProductsProductsIndexRouteImport.update({
    id: '/products/products/',
    path: '/products/products/',
    getParentRoute: () => dasboardRouteRoute,
  } as any)
const dasboardOrdersReturnsIndexRoute =
  dasboardOrdersReturnsIndexRouteImport.update({
    id: '/orders/returns/',
    path: '/orders/returns/',
    getParentRoute: () => dasboardRouteRoute,
  } as any)
const dasboardOrdersOrdersIndexRoute =
  dasboardOrdersOrdersIndexRouteImport.update({
    id: '/orders/orders/',
    path: '/orders/orders/',
    getParentRoute: () => dasboardRouteRoute,
  } as any)
const dasboardInventorySupplyReturnsIndexRoute =
  dasboardInventorySupplyReturnsIndexRouteImport.update({
    id: '/inventory/supply-returns/',
    path: '/inventory/supply-returns/',
    getParentRoute: () => dasboardRouteRoute,
  } as any)
const dasboardInventoryStockTransfersIndexRoute =
  dasboardInventoryStockTransfersIndexRouteImport.update({
    id: '/inventory/stock-transfers/',
    path: '/inventory/stock-transfers/',
    getParentRoute: () => dasboardRouteRoute,
  } as any)
const dasboardInventoryStockBatchsIndexRoute =
  dasboardInventoryStockBatchsIndexRouteImport.update({
    id: '/inventory/stock-batchs/',
    path: '/inventory/stock-batchs/',
    getParentRoute: () => dasboardRouteRoute,
  } as any)
const dasboardFinanceAccountsIndexRoute =
  dasboardFinanceAccountsIndexRouteImport.update({
    id: '/finance/accounts/',
    path: '/finance/accounts/',
    getParentRoute: () => dasboardRouteRoute,
  } as any)
const dasboardProductsServicesCreateRoute =
  dasboardProductsServicesCreateRouteImport.update({
    id: '/products/services/create',
    path: '/products/services/create',
    getParentRoute: () => dasboardRouteRoute,
  } as any)
const dasboardProductsServicesIdRoute =
  dasboardProductsServicesIdRouteImport.update({
    id: '/products/services/$id',
    path: '/products/services/$id',
    getParentRoute: () => dasboardRouteRoute,
  } as any)
const dasboardProductsProductsCreateRoute =
  dasboardProductsProductsCreateRouteImport.update({
    id: '/products/products/create',
    path: '/products/products/create',
    getParentRoute: () => dasboardRouteRoute,
  } as any)
const dasboardProductsProductsIdRoute =
  dasboardProductsProductsIdRouteImport.update({
    id: '/products/products/$id',
    path: '/products/products/$id',
    getParentRoute: () => dasboardRouteRoute,
  } as any)
const dasboardOrdersReturnsCreateRoute =
  dasboardOrdersReturnsCreateRouteImport.update({
    id: '/orders/returns/create',
    path: '/orders/returns/create',
    getParentRoute: () => dasboardRouteRoute,
  } as any)
const dasboardOrdersReturnsIdRoute = dasboardOrdersReturnsIdRouteImport.update({
  id: '/orders/returns/$id',
  path: '/orders/returns/$id',
  getParentRoute: () => dasboardRouteRoute,
} as any)
const dasboardOrdersOrdersCreateRoute =
  dasboardOrdersOrdersCreateRouteImport.update({
    id: '/orders/orders/create',
    path: '/orders/orders/create',
    getParentRoute: () => dasboardRouteRoute,
  } as any)
const dasboardOrdersOrdersIdRoute = dasboardOrdersOrdersIdRouteImport.update({
  id: '/orders/orders/$id',
  path: '/orders/orders/$id',
  getParentRoute: () => dasboardRouteRoute,
} as any)
const dasboardInventorySupplyReturnsCreateRoute =
  dasboardInventorySupplyReturnsCreateRouteImport.update({
    id: '/inventory/supply-returns/create',
    path: '/inventory/supply-returns/create',
    getParentRoute: () => dasboardRouteRoute,
  } as any)
const dasboardInventorySupplyReturnsIdRoute =
  dasboardInventorySupplyReturnsIdRouteImport.update({
    id: '/inventory/supply-returns/$id',
    path: '/inventory/supply-returns/$id',
    getParentRoute: () => dasboardRouteRoute,
  } as any)
const dasboardInventoryStockTransfersCreateRoute =
  dasboardInventoryStockTransfersCreateRouteImport.update({
    id: '/inventory/stock-transfers/create',
    path: '/inventory/stock-transfers/create',
    getParentRoute: () => dasboardRouteRoute,
  } as any)
const dasboardInventoryStockBatchsCreateRoute =
  dasboardInventoryStockBatchsCreateRouteImport.update({
    id: '/inventory/stock-batchs/create',
    path: '/inventory/stock-batchs/create',
    getParentRoute: () => dasboardRouteRoute,
  } as any)
const dasboardFinanceDebtsSuppliersDebtsRoute =
  dasboardFinanceDebtsSuppliersDebtsRouteImport.update({
    id: '/finance/debts/suppliers-debts',
    path: '/finance/debts/suppliers-debts',
    getParentRoute: () => dasboardRouteRoute,
  } as any)
const dasboardFinanceDebtsSuppliersCreditsRoute =
  dasboardFinanceDebtsSuppliersCreditsRouteImport.update({
    id: '/finance/debts/suppliers-credits',
    path: '/finance/debts/suppliers-credits',
    getParentRoute: () => dasboardRouteRoute,
  } as any)
const dasboardFinanceDebtsCustomersDebtsRoute =
  dasboardFinanceDebtsCustomersDebtsRouteImport.update({
    id: '/finance/debts/customers-debts',
    path: '/finance/debts/customers-debts',
    getParentRoute: () => dasboardRouteRoute,
  } as any)
const dasboardFinanceAccountsIdRoute =
  dasboardFinanceAccountsIdRouteImport.update({
    id: '/finance/accounts/$id',
    path: '/finance/accounts/$id',
    getParentRoute: () => dasboardRouteRoute,
  } as any)
const dasboardEmployeesIdViewRoute = dasboardEmployeesIdViewRouteImport.update({
  id: '/employees/$id/view',
  path: '/employees/$id/view',
  getParentRoute: () => dasboardRouteRoute,
} as any)
const dasboardEmployeesIdEditRoute = dasboardEmployeesIdEditRouteImport.update({
  id: '/employees/$id/edit',
  path: '/employees/$id/edit',
  getParentRoute: () => dasboardRouteRoute,
} as any)
const dasboardInventoryStockBatchsIdQuantityTransferOutRoute =
  dasboardInventoryStockBatchsIdQuantityTransferOutRouteImport.update({
    id: '/inventory/stock-batchs/$id/quantity-transfer-out',
    path: '/inventory/stock-batchs/$id/quantity-transfer-out',
    getParentRoute: () => dasboardRouteRoute,
  } as any)
const dasboardInventoryStockBatchsIdQuantityTransferInRoute =
  dasboardInventoryStockBatchsIdQuantityTransferInRouteImport.update({
    id: '/inventory/stock-batchs/$id/quantity-transfer-in',
    path: '/inventory/stock-batchs/$id/quantity-transfer-in',
    getParentRoute: () => dasboardRouteRoute,
  } as any)
const dasboardInventoryStockBatchsIdQuantitySupplyReturnRoute =
  dasboardInventoryStockBatchsIdQuantitySupplyReturnRouteImport.update({
    id: '/inventory/stock-batchs/$id/quantity-supply-return',
    path: '/inventory/stock-batchs/$id/quantity-supply-return',
    getParentRoute: () => dasboardRouteRoute,
  } as any)
const dasboardInventoryStockBatchsIdQuantitySoldRoute =
  dasboardInventoryStockBatchsIdQuantitySoldRouteImport.update({
    id: '/inventory/stock-batchs/$id/quantity-sold',
    path: '/inventory/stock-batchs/$id/quantity-sold',
    getParentRoute: () => dasboardRouteRoute,
  } as any)
const dasboardInventoryStockBatchsIdQuantitySaleReturnRoute =
  dasboardInventoryStockBatchsIdQuantitySaleReturnRouteImport.update({
    id: '/inventory/stock-batchs/$id/quantity-sale-return',
    path: '/inventory/stock-batchs/$id/quantity-sale-return',
    getParentRoute: () => dasboardRouteRoute,
  } as any)
const dasboardInventoryStockBatchsIdQuantityAdjustedRoute =
  dasboardInventoryStockBatchsIdQuantityAdjustedRouteImport.update({
    id: '/inventory/stock-batchs/$id/quantity-adjusted',
    path: '/inventory/stock-batchs/$id/quantity-adjusted',
    getParentRoute: () => dasboardRouteRoute,
  } as any)
const dasboardInventoryStockBatchsIdPriceChangesRoute =
  dasboardInventoryStockBatchsIdPriceChangesRouteImport.update({
    id: '/inventory/stock-batchs/$id/price-changes',
    path: '/inventory/stock-batchs/$id/price-changes',
    getParentRoute: () => dasboardRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/audit-logs': typeof dasboardAuditLogsRoute
  '/dashboard': typeof dasboardDashboardRoute
  '/pos': typeof dasboardPosRoute
  '/profile': typeof dasboardProfileRoute
  '/settings': typeof dasboardSettingsRoute
  '/customers/$id': typeof dasboardCustomersIdRoute
  '/employees/create': typeof dasboardEmployeesCreateRoute
  '/finance/categories': typeof dasboardFinanceCategoriesRoute
  '/finance/expense-categories': typeof dasboardFinanceExpenseCategoriesRoute
  '/finance/expenses': typeof dasboardFinanceExpensesRoute
  '/finance/income-categories': typeof dasboardFinanceIncomeCategoriesRoute
  '/finance/incomes': typeof dasboardFinanceIncomesRoute
  '/finance/transfers': typeof dasboardFinanceTransfersRoute
  '/inventory/warehouses': typeof dasboardInventoryWarehousesRoute
  '/products/categories': typeof dasboardProductsCategoriesRoute
  '/products/suppliers': typeof dasboardProductsSuppliersRoute
  '/products/types': typeof dasboardProductsTypesRoute
  '/auth/login': typeof onboardingAuthLoginRoute
  '/auth/logout': typeof onboardingAuthLogoutRoute
  '/auth/password-forgot': typeof onboardingAuthPasswordForgotRoute
  '/auth/register': typeof onboardingAuthRegisterRoute
  '/auth/reset-password': typeof onboardingAuthResetPasswordRoute
  '/auth/verify-account': typeof onboardingAuthVerifyAccountRoute
  '/auth/verify-failed': typeof onboardingAuthVerifyFailedRoute
  '/auth/verify-success': typeof onboardingAuthVerifySuccessRoute
  '/setup/create-business': typeof onboardingSetupCreateBusinessRoute
  '/setup/create-shop': typeof onboardingSetupCreateShopRoute
  '/setup/select-shop': typeof onboardingSetupSelectShopRoute
  '/customers': typeof dasboardCustomersIndexRoute
  '/employees': typeof dasboardEmployeesIndexRoute
  '/finance': typeof dasboardFinanceIndexRoute
  '/inventory': typeof dasboardInventoryIndexRoute
  '/employees/$id/edit': typeof dasboardEmployeesIdEditRoute
  '/employees/$id/view': typeof dasboardEmployeesIdViewRoute
  '/finance/accounts/$id': typeof dasboardFinanceAccountsIdRoute
  '/finance/debts/customers-debts': typeof dasboardFinanceDebtsCustomersDebtsRoute
  '/finance/debts/suppliers-credits': typeof dasboardFinanceDebtsSuppliersCreditsRoute
  '/finance/debts/suppliers-debts': typeof dasboardFinanceDebtsSuppliersDebtsRoute
  '/inventory/stock-batchs/create': typeof dasboardInventoryStockBatchsCreateRoute
  '/inventory/stock-transfers/create': typeof dasboardInventoryStockTransfersCreateRoute
  '/inventory/supply-returns/$id': typeof dasboardInventorySupplyReturnsIdRoute
  '/inventory/supply-returns/create': typeof dasboardInventorySupplyReturnsCreateRoute
  '/orders/orders/$id': typeof dasboardOrdersOrdersIdRoute
  '/orders/orders/create': typeof dasboardOrdersOrdersCreateRoute
  '/orders/returns/$id': typeof dasboardOrdersReturnsIdRoute
  '/orders/returns/create': typeof dasboardOrdersReturnsCreateRoute
  '/products/products/$id': typeof dasboardProductsProductsIdRoute
  '/products/products/create': typeof dasboardProductsProductsCreateRoute
  '/products/services/$id': typeof dasboardProductsServicesIdRoute
  '/products/services/create': typeof dasboardProductsServicesCreateRoute
  '/finance/accounts': typeof dasboardFinanceAccountsIndexRoute
  '/inventory/stock-batchs': typeof dasboardInventoryStockBatchsIndexRoute
  '/inventory/stock-transfers': typeof dasboardInventoryStockTransfersIndexRoute
  '/inventory/supply-returns': typeof dasboardInventorySupplyReturnsIndexRoute
  '/orders/orders': typeof dasboardOrdersOrdersIndexRoute
  '/orders/returns': typeof dasboardOrdersReturnsIndexRoute
  '/products/products': typeof dasboardProductsProductsIndexRoute
  '/products/services': typeof dasboardProductsServicesIndexRoute
  '/inventory/stock-batchs/$id/price-changes': typeof dasboardInventoryStockBatchsIdPriceChangesRoute
  '/inventory/stock-batchs/$id/quantity-adjusted': typeof dasboardInventoryStockBatchsIdQuantityAdjustedRoute
  '/inventory/stock-batchs/$id/quantity-sale-return': typeof dasboardInventoryStockBatchsIdQuantitySaleReturnRoute
  '/inventory/stock-batchs/$id/quantity-sold': typeof dasboardInventoryStockBatchsIdQuantitySoldRoute
  '/inventory/stock-batchs/$id/quantity-supply-return': typeof dasboardInventoryStockBatchsIdQuantitySupplyReturnRoute
  '/inventory/stock-batchs/$id/quantity-transfer-in': typeof dasboardInventoryStockBatchsIdQuantityTransferInRoute
  '/inventory/stock-batchs/$id/quantity-transfer-out': typeof dasboardInventoryStockBatchsIdQuantityTransferOutRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/audit-logs': typeof dasboardAuditLogsRoute
  '/dashboard': typeof dasboardDashboardRoute
  '/pos': typeof dasboardPosRoute
  '/profile': typeof dasboardProfileRoute
  '/settings': typeof dasboardSettingsRoute
  '/customers/$id': typeof dasboardCustomersIdRoute
  '/employees/create': typeof dasboardEmployeesCreateRoute
  '/finance/categories': typeof dasboardFinanceCategoriesRoute
  '/finance/expense-categories': typeof dasboardFinanceExpenseCategoriesRoute
  '/finance/expenses': typeof dasboardFinanceExpensesRoute
  '/finance/income-categories': typeof dasboardFinanceIncomeCategoriesRoute
  '/finance/incomes': typeof dasboardFinanceIncomesRoute
  '/finance/transfers': typeof dasboardFinanceTransfersRoute
  '/inventory/warehouses': typeof dasboardInventoryWarehousesRoute
  '/products/categories': typeof dasboardProductsCategoriesRoute
  '/products/suppliers': typeof dasboardProductsSuppliersRoute
  '/products/types': typeof dasboardProductsTypesRoute
  '/auth/login': typeof onboardingAuthLoginRoute
  '/auth/logout': typeof onboardingAuthLogoutRoute
  '/auth/password-forgot': typeof onboardingAuthPasswordForgotRoute
  '/auth/register': typeof onboardingAuthRegisterRoute
  '/auth/reset-password': typeof onboardingAuthResetPasswordRoute
  '/auth/verify-account': typeof onboardingAuthVerifyAccountRoute
  '/auth/verify-failed': typeof onboardingAuthVerifyFailedRoute
  '/auth/verify-success': typeof onboardingAuthVerifySuccessRoute
  '/setup/create-business': typeof onboardingSetupCreateBusinessRoute
  '/setup/create-shop': typeof onboardingSetupCreateShopRoute
  '/setup/select-shop': typeof onboardingSetupSelectShopRoute
  '/customers': typeof dasboardCustomersIndexRoute
  '/employees': typeof dasboardEmployeesIndexRoute
  '/finance': typeof dasboardFinanceIndexRoute
  '/inventory': typeof dasboardInventoryIndexRoute
  '/employees/$id/edit': typeof dasboardEmployeesIdEditRoute
  '/employees/$id/view': typeof dasboardEmployeesIdViewRoute
  '/finance/accounts/$id': typeof dasboardFinanceAccountsIdRoute
  '/finance/debts/customers-debts': typeof dasboardFinanceDebtsCustomersDebtsRoute
  '/finance/debts/suppliers-credits': typeof dasboardFinanceDebtsSuppliersCreditsRoute
  '/finance/debts/suppliers-debts': typeof dasboardFinanceDebtsSuppliersDebtsRoute
  '/inventory/stock-batchs/create': typeof dasboardInventoryStockBatchsCreateRoute
  '/inventory/stock-transfers/create': typeof dasboardInventoryStockTransfersCreateRoute
  '/inventory/supply-returns/$id': typeof dasboardInventorySupplyReturnsIdRoute
  '/inventory/supply-returns/create': typeof dasboardInventorySupplyReturnsCreateRoute
  '/orders/orders/$id': typeof dasboardOrdersOrdersIdRoute
  '/orders/orders/create': typeof dasboardOrdersOrdersCreateRoute
  '/orders/returns/$id': typeof dasboardOrdersReturnsIdRoute
  '/orders/returns/create': typeof dasboardOrdersReturnsCreateRoute
  '/products/products/$id': typeof dasboardProductsProductsIdRoute
  '/products/products/create': typeof dasboardProductsProductsCreateRoute
  '/products/services/$id': typeof dasboardProductsServicesIdRoute
  '/products/services/create': typeof dasboardProductsServicesCreateRoute
  '/finance/accounts': typeof dasboardFinanceAccountsIndexRoute
  '/inventory/stock-batchs': typeof dasboardInventoryStockBatchsIndexRoute
  '/inventory/stock-transfers': typeof dasboardInventoryStockTransfersIndexRoute
  '/inventory/supply-returns': typeof dasboardInventorySupplyReturnsIndexRoute
  '/orders/orders': typeof dasboardOrdersOrdersIndexRoute
  '/orders/returns': typeof dasboardOrdersReturnsIndexRoute
  '/products/products': typeof dasboardProductsProductsIndexRoute
  '/products/services': typeof dasboardProductsServicesIndexRoute
  '/inventory/stock-batchs/$id/price-changes': typeof dasboardInventoryStockBatchsIdPriceChangesRoute
  '/inventory/stock-batchs/$id/quantity-adjusted': typeof dasboardInventoryStockBatchsIdQuantityAdjustedRoute
  '/inventory/stock-batchs/$id/quantity-sale-return': typeof dasboardInventoryStockBatchsIdQuantitySaleReturnRoute
  '/inventory/stock-batchs/$id/quantity-sold': typeof dasboardInventoryStockBatchsIdQuantitySoldRoute
  '/inventory/stock-batchs/$id/quantity-supply-return': typeof dasboardInventoryStockBatchsIdQuantitySupplyReturnRoute
  '/inventory/stock-batchs/$id/quantity-transfer-in': typeof dasboardInventoryStockBatchsIdQuantityTransferInRoute
  '/inventory/stock-batchs/$id/quantity-transfer-out': typeof dasboardInventoryStockBatchsIdQuantityTransferOutRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/(dasboard)': typeof dasboardRouteRouteWithChildren
  '/(dasboard)/audit-logs': typeof dasboardAuditLogsRoute
  '/(dasboard)/dashboard': typeof dasboardDashboardRoute
  '/(dasboard)/pos': typeof dasboardPosRoute
  '/(dasboard)/profile': typeof dasboardProfileRoute
  '/(dasboard)/settings': typeof dasboardSettingsRoute
  '/(dasboard)/customers/$id': typeof dasboardCustomersIdRoute
  '/(dasboard)/employees/create': typeof dasboardEmployeesCreateRoute
  '/(dasboard)/finance/categories': typeof dasboardFinanceCategoriesRoute
  '/(dasboard)/finance/expense-categories': typeof dasboardFinanceExpenseCategoriesRoute
  '/(dasboard)/finance/expenses': typeof dasboardFinanceExpensesRoute
  '/(dasboard)/finance/income-categories': typeof dasboardFinanceIncomeCategoriesRoute
  '/(dasboard)/finance/incomes': typeof dasboardFinanceIncomesRoute
  '/(dasboard)/finance/transfers': typeof dasboardFinanceTransfersRoute
  '/(dasboard)/inventory/warehouses': typeof dasboardInventoryWarehousesRoute
  '/(dasboard)/products/categories': typeof dasboardProductsCategoriesRoute
  '/(dasboard)/products/suppliers': typeof dasboardProductsSuppliersRoute
  '/(dasboard)/products/types': typeof dasboardProductsTypesRoute
  '/(onboarding)/auth/login': typeof onboardingAuthLoginRoute
  '/(onboarding)/auth/logout': typeof onboardingAuthLogoutRoute
  '/(onboarding)/auth/password-forgot': typeof onboardingAuthPasswordForgotRoute
  '/(onboarding)/auth/register': typeof onboardingAuthRegisterRoute
  '/(onboarding)/auth/reset-password': typeof onboardingAuthResetPasswordRoute
  '/(onboarding)/auth/verify-account': typeof onboardingAuthVerifyAccountRoute
  '/(onboarding)/auth/verify-failed': typeof onboardingAuthVerifyFailedRoute
  '/(onboarding)/auth/verify-success': typeof onboardingAuthVerifySuccessRoute
  '/(onboarding)/setup/create-business': typeof onboardingSetupCreateBusinessRoute
  '/(onboarding)/setup/create-shop': typeof onboardingSetupCreateShopRoute
  '/(onboarding)/setup/select-shop': typeof onboardingSetupSelectShopRoute
  '/(dasboard)/customers/': typeof dasboardCustomersIndexRoute
  '/(dasboard)/employees/': typeof dasboardEmployeesIndexRoute
  '/(dasboard)/finance/': typeof dasboardFinanceIndexRoute
  '/(dasboard)/inventory/': typeof dasboardInventoryIndexRoute
  '/(dasboard)/employees/$id/edit': typeof dasboardEmployeesIdEditRoute
  '/(dasboard)/employees/$id/view': typeof dasboardEmployeesIdViewRoute
  '/(dasboard)/finance/accounts/$id': typeof dasboardFinanceAccountsIdRoute
  '/(dasboard)/finance/debts/customers-debts': typeof dasboardFinanceDebtsCustomersDebtsRoute
  '/(dasboard)/finance/debts/suppliers-credits': typeof dasboardFinanceDebtsSuppliersCreditsRoute
  '/(dasboard)/finance/debts/suppliers-debts': typeof dasboardFinanceDebtsSuppliersDebtsRoute
  '/(dasboard)/inventory/stock-batchs/create': typeof dasboardInventoryStockBatchsCreateRoute
  '/(dasboard)/inventory/stock-transfers/create': typeof dasboardInventoryStockTransfersCreateRoute
  '/(dasboard)/inventory/supply-returns/$id': typeof dasboardInventorySupplyReturnsIdRoute
  '/(dasboard)/inventory/supply-returns/create': typeof dasboardInventorySupplyReturnsCreateRoute
  '/(dasboard)/orders/orders/$id': typeof dasboardOrdersOrdersIdRoute
  '/(dasboard)/orders/orders/create': typeof dasboardOrdersOrdersCreateRoute
  '/(dasboard)/orders/returns/$id': typeof dasboardOrdersReturnsIdRoute
  '/(dasboard)/orders/returns/create': typeof dasboardOrdersReturnsCreateRoute
  '/(dasboard)/products/products/$id': typeof dasboardProductsProductsIdRoute
  '/(dasboard)/products/products/create': typeof dasboardProductsProductsCreateRoute
  '/(dasboard)/products/services/$id': typeof dasboardProductsServicesIdRoute
  '/(dasboard)/products/services/create': typeof dasboardProductsServicesCreateRoute
  '/(dasboard)/finance/accounts/': typeof dasboardFinanceAccountsIndexRoute
  '/(dasboard)/inventory/stock-batchs/': typeof dasboardInventoryStockBatchsIndexRoute
  '/(dasboard)/inventory/stock-transfers/': typeof dasboardInventoryStockTransfersIndexRoute
  '/(dasboard)/inventory/supply-returns/': typeof dasboardInventorySupplyReturnsIndexRoute
  '/(dasboard)/orders/orders/': typeof dasboardOrdersOrdersIndexRoute
  '/(dasboard)/orders/returns/': typeof dasboardOrdersReturnsIndexRoute
  '/(dasboard)/products/products/': typeof dasboardProductsProductsIndexRoute
  '/(dasboard)/products/services/': typeof dasboardProductsServicesIndexRoute
  '/(dasboard)/inventory/stock-batchs/$id/price-changes': typeof dasboardInventoryStockBatchsIdPriceChangesRoute
  '/(dasboard)/inventory/stock-batchs/$id/quantity-adjusted': typeof dasboardInventoryStockBatchsIdQuantityAdjustedRoute
  '/(dasboard)/inventory/stock-batchs/$id/quantity-sale-return': typeof dasboardInventoryStockBatchsIdQuantitySaleReturnRoute
  '/(dasboard)/inventory/stock-batchs/$id/quantity-sold': typeof dasboardInventoryStockBatchsIdQuantitySoldRoute
  '/(dasboard)/inventory/stock-batchs/$id/quantity-supply-return': typeof dasboardInventoryStockBatchsIdQuantitySupplyReturnRoute
  '/(dasboard)/inventory/stock-batchs/$id/quantity-transfer-in': typeof dasboardInventoryStockBatchsIdQuantityTransferInRoute
  '/(dasboard)/inventory/stock-batchs/$id/quantity-transfer-out': typeof dasboardInventoryStockBatchsIdQuantityTransferOutRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/audit-logs'
    | '/dashboard'
    | '/pos'
    | '/profile'
    | '/settings'
    | '/customers/$id'
    | '/employees/create'
    | '/finance/categories'
    | '/finance/expense-categories'
    | '/finance/expenses'
    | '/finance/income-categories'
    | '/finance/incomes'
    | '/finance/transfers'
    | '/inventory/warehouses'
    | '/products/categories'
    | '/products/suppliers'
    | '/products/types'
    | '/auth/login'
    | '/auth/logout'
    | '/auth/password-forgot'
    | '/auth/register'
    | '/auth/reset-password'
    | '/auth/verify-account'
    | '/auth/verify-failed'
    | '/auth/verify-success'
    | '/setup/create-business'
    | '/setup/create-shop'
    | '/setup/select-shop'
    | '/customers'
    | '/employees'
    | '/finance'
    | '/inventory'
    | '/employees/$id/edit'
    | '/employees/$id/view'
    | '/finance/accounts/$id'
    | '/finance/debts/customers-debts'
    | '/finance/debts/suppliers-credits'
    | '/finance/debts/suppliers-debts'
    | '/inventory/stock-batchs/create'
    | '/inventory/stock-transfers/create'
    | '/inventory/supply-returns/$id'
    | '/inventory/supply-returns/create'
    | '/orders/orders/$id'
    | '/orders/orders/create'
    | '/orders/returns/$id'
    | '/orders/returns/create'
    | '/products/products/$id'
    | '/products/products/create'
    | '/products/services/$id'
    | '/products/services/create'
    | '/finance/accounts'
    | '/inventory/stock-batchs'
    | '/inventory/stock-transfers'
    | '/inventory/supply-returns'
    | '/orders/orders'
    | '/orders/returns'
    | '/products/products'
    | '/products/services'
    | '/inventory/stock-batchs/$id/price-changes'
    | '/inventory/stock-batchs/$id/quantity-adjusted'
    | '/inventory/stock-batchs/$id/quantity-sale-return'
    | '/inventory/stock-batchs/$id/quantity-sold'
    | '/inventory/stock-batchs/$id/quantity-supply-return'
    | '/inventory/stock-batchs/$id/quantity-transfer-in'
    | '/inventory/stock-batchs/$id/quantity-transfer-out'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/audit-logs'
    | '/dashboard'
    | '/pos'
    | '/profile'
    | '/settings'
    | '/customers/$id'
    | '/employees/create'
    | '/finance/categories'
    | '/finance/expense-categories'
    | '/finance/expenses'
    | '/finance/income-categories'
    | '/finance/incomes'
    | '/finance/transfers'
    | '/inventory/warehouses'
    | '/products/categories'
    | '/products/suppliers'
    | '/products/types'
    | '/auth/login'
    | '/auth/logout'
    | '/auth/password-forgot'
    | '/auth/register'
    | '/auth/reset-password'
    | '/auth/verify-account'
    | '/auth/verify-failed'
    | '/auth/verify-success'
    | '/setup/create-business'
    | '/setup/create-shop'
    | '/setup/select-shop'
    | '/customers'
    | '/employees'
    | '/finance'
    | '/inventory'
    | '/employees/$id/edit'
    | '/employees/$id/view'
    | '/finance/accounts/$id'
    | '/finance/debts/customers-debts'
    | '/finance/debts/suppliers-credits'
    | '/finance/debts/suppliers-debts'
    | '/inventory/stock-batchs/create'
    | '/inventory/stock-transfers/create'
    | '/inventory/supply-returns/$id'
    | '/inventory/supply-returns/create'
    | '/orders/orders/$id'
    | '/orders/orders/create'
    | '/orders/returns/$id'
    | '/orders/returns/create'
    | '/products/products/$id'
    | '/products/products/create'
    | '/products/services/$id'
    | '/products/services/create'
    | '/finance/accounts'
    | '/inventory/stock-batchs'
    | '/inventory/stock-transfers'
    | '/inventory/supply-returns'
    | '/orders/orders'
    | '/orders/returns'
    | '/products/products'
    | '/products/services'
    | '/inventory/stock-batchs/$id/price-changes'
    | '/inventory/stock-batchs/$id/quantity-adjusted'
    | '/inventory/stock-batchs/$id/quantity-sale-return'
    | '/inventory/stock-batchs/$id/quantity-sold'
    | '/inventory/stock-batchs/$id/quantity-supply-return'
    | '/inventory/stock-batchs/$id/quantity-transfer-in'
    | '/inventory/stock-batchs/$id/quantity-transfer-out'
  id:
    | '__root__'
    | '/'
    | '/(dasboard)'
    | '/(dasboard)/audit-logs'
    | '/(dasboard)/dashboard'
    | '/(dasboard)/pos'
    | '/(dasboard)/profile'
    | '/(dasboard)/settings'
    | '/(dasboard)/customers/$id'
    | '/(dasboard)/employees/create'
    | '/(dasboard)/finance/categories'
    | '/(dasboard)/finance/expense-categories'
    | '/(dasboard)/finance/expenses'
    | '/(dasboard)/finance/income-categories'
    | '/(dasboard)/finance/incomes'
    | '/(dasboard)/finance/transfers'
    | '/(dasboard)/inventory/warehouses'
    | '/(dasboard)/products/categories'
    | '/(dasboard)/products/suppliers'
    | '/(dasboard)/products/types'
    | '/(onboarding)/auth/login'
    | '/(onboarding)/auth/logout'
    | '/(onboarding)/auth/password-forgot'
    | '/(onboarding)/auth/register'
    | '/(onboarding)/auth/reset-password'
    | '/(onboarding)/auth/verify-account'
    | '/(onboarding)/auth/verify-failed'
    | '/(onboarding)/auth/verify-success'
    | '/(onboarding)/setup/create-business'
    | '/(onboarding)/setup/create-shop'
    | '/(onboarding)/setup/select-shop'
    | '/(dasboard)/customers/'
    | '/(dasboard)/employees/'
    | '/(dasboard)/finance/'
    | '/(dasboard)/inventory/'
    | '/(dasboard)/employees/$id/edit'
    | '/(dasboard)/employees/$id/view'
    | '/(dasboard)/finance/accounts/$id'
    | '/(dasboard)/finance/debts/customers-debts'
    | '/(dasboard)/finance/debts/suppliers-credits'
    | '/(dasboard)/finance/debts/suppliers-debts'
    | '/(dasboard)/inventory/stock-batchs/create'
    | '/(dasboard)/inventory/stock-transfers/create'
    | '/(dasboard)/inventory/supply-returns/$id'
    | '/(dasboard)/inventory/supply-returns/create'
    | '/(dasboard)/orders/orders/$id'
    | '/(dasboard)/orders/orders/create'
    | '/(dasboard)/orders/returns/$id'
    | '/(dasboard)/orders/returns/create'
    | '/(dasboard)/products/products/$id'
    | '/(dasboard)/products/products/create'
    | '/(dasboard)/products/services/$id'
    | '/(dasboard)/products/services/create'
    | '/(dasboard)/finance/accounts/'
    | '/(dasboard)/inventory/stock-batchs/'
    | '/(dasboard)/inventory/stock-transfers/'
    | '/(dasboard)/inventory/supply-returns/'
    | '/(dasboard)/orders/orders/'
    | '/(dasboard)/orders/returns/'
    | '/(dasboard)/products/products/'
    | '/(dasboard)/products/services/'
    | '/(dasboard)/inventory/stock-batchs/$id/price-changes'
    | '/(dasboard)/inventory/stock-batchs/$id/quantity-adjusted'
    | '/(dasboard)/inventory/stock-batchs/$id/quantity-sale-return'
    | '/(dasboard)/inventory/stock-batchs/$id/quantity-sold'
    | '/(dasboard)/inventory/stock-batchs/$id/quantity-supply-return'
    | '/(dasboard)/inventory/stock-batchs/$id/quantity-transfer-in'
    | '/(dasboard)/inventory/stock-batchs/$id/quantity-transfer-out'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  dasboardRouteRoute: typeof dasboardRouteRouteWithChildren
  onboardingAuthLoginRoute: typeof onboardingAuthLoginRoute
  onboardingAuthLogoutRoute: typeof onboardingAuthLogoutRoute
  onboardingAuthPasswordForgotRoute: typeof onboardingAuthPasswordForgotRoute
  onboardingAuthRegisterRoute: typeof onboardingAuthRegisterRoute
  onboardingAuthResetPasswordRoute: typeof onboardingAuthResetPasswordRoute
  onboardingAuthVerifyAccountRoute: typeof onboardingAuthVerifyAccountRoute
  onboardingAuthVerifyFailedRoute: typeof onboardingAuthVerifyFailedRoute
  onboardingAuthVerifySuccessRoute: typeof onboardingAuthVerifySuccessRoute
  onboardingSetupCreateBusinessRoute: typeof onboardingSetupCreateBusinessRoute
  onboardingSetupCreateShopRoute: typeof onboardingSetupCreateShopRoute
  onboardingSetupSelectShopRoute: typeof onboardingSetupSelectShopRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/(dasboard)': {
      id: '/(dasboard)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof dasboardRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(dasboard)/settings': {
      id: '/(dasboard)/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof dasboardSettingsRouteImport
      parentRoute: typeof dasboardRouteRoute
    }
    '/(dasboard)/profile': {
      id: '/(dasboard)/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof dasboardProfileRouteImport
      parentRoute: typeof dasboardRouteRoute
    }
    '/(dasboard)/pos': {
      id: '/(dasboard)/pos'
      path: '/pos'
      fullPath: '/pos'
      preLoaderRoute: typeof dasboardPosRouteImport
      parentRoute: typeof dasboardRouteRoute
    }
    '/(dasboard)/dashboard': {
      id: '/(dasboard)/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof dasboardDashboardRouteImport
      parentRoute: typeof dasboardRouteRoute
    }
    '/(dasboard)/audit-logs': {
      id: '/(dasboard)/audit-logs'
      path: '/audit-logs'
      fullPath: '/audit-logs'
      preLoaderRoute: typeof dasboardAuditLogsRouteImport
      parentRoute: typeof dasboardRouteRoute
    }
    '/(dasboard)/inventory/': {
      id: '/(dasboard)/inventory/'
      path: '/inventory'
      fullPath: '/inventory'
      preLoaderRoute: typeof dasboardInventoryIndexRouteImport
      parentRoute: typeof dasboardRouteRoute
    }
    '/(dasboard)/finance/': {
      id: '/(dasboard)/finance/'
      path: '/finance'
      fullPath: '/finance'
      preLoaderRoute: typeof dasboardFinanceIndexRouteImport
      parentRoute: typeof dasboardRouteRoute
    }
    '/(dasboard)/employees/': {
      id: '/(dasboard)/employees/'
      path: '/employees'
      fullPath: '/employees'
      preLoaderRoute: typeof dasboardEmployeesIndexRouteImport
      parentRoute: typeof dasboardRouteRoute
    }
    '/(dasboard)/customers/': {
      id: '/(dasboard)/customers/'
      path: '/customers'
      fullPath: '/customers'
      preLoaderRoute: typeof dasboardCustomersIndexRouteImport
      parentRoute: typeof dasboardRouteRoute
    }
    '/(onboarding)/setup/select-shop': {
      id: '/(onboarding)/setup/select-shop'
      path: '/setup/select-shop'
      fullPath: '/setup/select-shop'
      preLoaderRoute: typeof onboardingSetupSelectShopRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(onboarding)/setup/create-shop': {
      id: '/(onboarding)/setup/create-shop'
      path: '/setup/create-shop'
      fullPath: '/setup/create-shop'
      preLoaderRoute: typeof onboardingSetupCreateShopRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(onboarding)/setup/create-business': {
      id: '/(onboarding)/setup/create-business'
      path: '/setup/create-business'
      fullPath: '/setup/create-business'
      preLoaderRoute: typeof onboardingSetupCreateBusinessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(onboarding)/auth/verify-success': {
      id: '/(onboarding)/auth/verify-success'
      path: '/auth/verify-success'
      fullPath: '/auth/verify-success'
      preLoaderRoute: typeof onboardingAuthVerifySuccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(onboarding)/auth/verify-failed': {
      id: '/(onboarding)/auth/verify-failed'
      path: '/auth/verify-failed'
      fullPath: '/auth/verify-failed'
      preLoaderRoute: typeof onboardingAuthVerifyFailedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(onboarding)/auth/verify-account': {
      id: '/(onboarding)/auth/verify-account'
      path: '/auth/verify-account'
      fullPath: '/auth/verify-account'
      preLoaderRoute: typeof onboardingAuthVerifyAccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(onboarding)/auth/reset-password': {
      id: '/(onboarding)/auth/reset-password'
      path: '/auth/reset-password'
      fullPath: '/auth/reset-password'
      preLoaderRoute: typeof onboardingAuthResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(onboarding)/auth/register': {
      id: '/(onboarding)/auth/register'
      path: '/auth/register'
      fullPath: '/auth/register'
      preLoaderRoute: typeof onboardingAuthRegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(onboarding)/auth/password-forgot': {
      id: '/(onboarding)/auth/password-forgot'
      path: '/auth/password-forgot'
      fullPath: '/auth/password-forgot'
      preLoaderRoute: typeof onboardingAuthPasswordForgotRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(onboarding)/auth/logout': {
      id: '/(onboarding)/auth/logout'
      path: '/auth/logout'
      fullPath: '/auth/logout'
      preLoaderRoute: typeof onboardingAuthLogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(onboarding)/auth/login': {
      id: '/(onboarding)/auth/login'
      path: '/auth/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof onboardingAuthLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(dasboard)/products/types': {
      id: '/(dasboard)/products/types'
      path: '/products/types'
      fullPath: '/products/types'
      preLoaderRoute: typeof dasboardProductsTypesRouteImport
      parentRoute: typeof dasboardRouteRoute
    }
    '/(dasboard)/products/suppliers': {
      id: '/(dasboard)/products/suppliers'
      path: '/products/suppliers'
      fullPath: '/products/suppliers'
      preLoaderRoute: typeof dasboardProductsSuppliersRouteImport
      parentRoute: typeof dasboardRouteRoute
    }
    '/(dasboard)/products/categories': {
      id: '/(dasboard)/products/categories'
      path: '/products/categories'
      fullPath: '/products/categories'
      preLoaderRoute: typeof dasboardProductsCategoriesRouteImport
      parentRoute: typeof dasboardRouteRoute
    }
    '/(dasboard)/inventory/warehouses': {
      id: '/(dasboard)/inventory/warehouses'
      path: '/inventory/warehouses'
      fullPath: '/inventory/warehouses'
      preLoaderRoute: typeof dasboardInventoryWarehousesRouteImport
      parentRoute: typeof dasboardRouteRoute
    }
    '/(dasboard)/finance/transfers': {
      id: '/(dasboard)/finance/transfers'
      path: '/finance/transfers'
      fullPath: '/finance/transfers'
      preLoaderRoute: typeof dasboardFinanceTransfersRouteImport
      parentRoute: typeof dasboardRouteRoute
    }
    '/(dasboard)/finance/incomes': {
      id: '/(dasboard)/finance/incomes'
      path: '/finance/incomes'
      fullPath: '/finance/incomes'
      preLoaderRoute: typeof dasboardFinanceIncomesRouteImport
      parentRoute: typeof dasboardRouteRoute
    }
    '/(dasboard)/finance/income-categories': {
      id: '/(dasboard)/finance/income-categories'
      path: '/finance/income-categories'
      fullPath: '/finance/income-categories'
      preLoaderRoute: typeof dasboardFinanceIncomeCategoriesRouteImport
      parentRoute: typeof dasboardRouteRoute
    }
    '/(dasboard)/finance/expenses': {
      id: '/(dasboard)/finance/expenses'
      path: '/finance/expenses'
      fullPath: '/finance/expenses'
      preLoaderRoute: typeof dasboardFinanceExpensesRouteImport
      parentRoute: typeof dasboardRouteRoute
    }
    '/(dasboard)/finance/expense-categories': {
      id: '/(dasboard)/finance/expense-categories'
      path: '/finance/expense-categories'
      fullPath: '/finance/expense-categories'
      preLoaderRoute: typeof dasboardFinanceExpenseCategoriesRouteImport
      parentRoute: typeof dasboardRouteRoute
    }
    '/(dasboard)/finance/categories': {
      id: '/(dasboard)/finance/categories'
      path: '/finance/categories'
      fullPath: '/finance/categories'
      preLoaderRoute: typeof dasboardFinanceCategoriesRouteImport
      parentRoute: typeof dasboardRouteRoute
    }
    '/(dasboard)/employees/create': {
      id: '/(dasboard)/employees/create'
      path: '/employees/create'
      fullPath: '/employees/create'
      preLoaderRoute: typeof dasboardEmployeesCreateRouteImport
      parentRoute: typeof dasboardRouteRoute
    }
    '/(dasboard)/customers/$id': {
      id: '/(dasboard)/customers/$id'
      path: '/customers/$id'
      fullPath: '/customers/$id'
      preLoaderRoute: typeof dasboardCustomersIdRouteImport
      parentRoute: typeof dasboardRouteRoute
    }
    '/(dasboard)/products/services/': {
      id: '/(dasboard)/products/services/'
      path: '/products/services'
      fullPath: '/products/services'
      preLoaderRoute: typeof dasboardProductsServicesIndexRouteImport
      parentRoute: typeof dasboardRouteRoute
    }
    '/(dasboard)/products/products/': {
      id: '/(dasboard)/products/products/'
      path: '/products/products'
      fullPath: '/products/products'
      preLoaderRoute: typeof dasboardProductsProductsIndexRouteImport
      parentRoute: typeof dasboardRouteRoute
    }
    '/(dasboard)/orders/returns/': {
      id: '/(dasboard)/orders/returns/'
      path: '/orders/returns'
      fullPath: '/orders/returns'
      preLoaderRoute: typeof dasboardOrdersReturnsIndexRouteImport
      parentRoute: typeof dasboardRouteRoute
    }
    '/(dasboard)/orders/orders/': {
      id: '/(dasboard)/orders/orders/'
      path: '/orders/orders'
      fullPath: '/orders/orders'
      preLoaderRoute: typeof dasboardOrdersOrdersIndexRouteImport
      parentRoute: typeof dasboardRouteRoute
    }
    '/(dasboard)/inventory/supply-returns/': {
      id: '/(dasboard)/inventory/supply-returns/'
      path: '/inventory/supply-returns'
      fullPath: '/inventory/supply-returns'
      preLoaderRoute: typeof dasboardInventorySupplyReturnsIndexRouteImport
      parentRoute: typeof dasboardRouteRoute
    }
    '/(dasboard)/inventory/stock-transfers/': {
      id: '/(dasboard)/inventory/stock-transfers/'
      path: '/inventory/stock-transfers'
      fullPath: '/inventory/stock-transfers'
      preLoaderRoute: typeof dasboardInventoryStockTransfersIndexRouteImport
      parentRoute: typeof dasboardRouteRoute
    }
    '/(dasboard)/inventory/stock-batchs/': {
      id: '/(dasboard)/inventory/stock-batchs/'
      path: '/inventory/stock-batchs'
      fullPath: '/inventory/stock-batchs'
      preLoaderRoute: typeof dasboardInventoryStockBatchsIndexRouteImport
      parentRoute: typeof dasboardRouteRoute
    }
    '/(dasboard)/finance/accounts/': {
      id: '/(dasboard)/finance/accounts/'
      path: '/finance/accounts'
      fullPath: '/finance/accounts'
      preLoaderRoute: typeof dasboardFinanceAccountsIndexRouteImport
      parentRoute: typeof dasboardRouteRoute
    }
    '/(dasboard)/products/services/create': {
      id: '/(dasboard)/products/services/create'
      path: '/products/services/create'
      fullPath: '/products/services/create'
      preLoaderRoute: typeof dasboardProductsServicesCreateRouteImport
      parentRoute: typeof dasboardRouteRoute
    }
    '/(dasboard)/products/services/$id': {
      id: '/(dasboard)/products/services/$id'
      path: '/products/services/$id'
      fullPath: '/products/services/$id'
      preLoaderRoute: typeof dasboardProductsServicesIdRouteImport
      parentRoute: typeof dasboardRouteRoute
    }
    '/(dasboard)/products/products/create': {
      id: '/(dasboard)/products/products/create'
      path: '/products/products/create'
      fullPath: '/products/products/create'
      preLoaderRoute: typeof dasboardProductsProductsCreateRouteImport
      parentRoute: typeof dasboardRouteRoute
    }
    '/(dasboard)/products/products/$id': {
      id: '/(dasboard)/products/products/$id'
      path: '/products/products/$id'
      fullPath: '/products/products/$id'
      preLoaderRoute: typeof dasboardProductsProductsIdRouteImport
      parentRoute: typeof dasboardRouteRoute
    }
    '/(dasboard)/orders/returns/create': {
      id: '/(dasboard)/orders/returns/create'
      path: '/orders/returns/create'
      fullPath: '/orders/returns/create'
      preLoaderRoute: typeof dasboardOrdersReturnsCreateRouteImport
      parentRoute: typeof dasboardRouteRoute
    }
    '/(dasboard)/orders/returns/$id': {
      id: '/(dasboard)/orders/returns/$id'
      path: '/orders/returns/$id'
      fullPath: '/orders/returns/$id'
      preLoaderRoute: typeof dasboardOrdersReturnsIdRouteImport
      parentRoute: typeof dasboardRouteRoute
    }
    '/(dasboard)/orders/orders/create': {
      id: '/(dasboard)/orders/orders/create'
      path: '/orders/orders/create'
      fullPath: '/orders/orders/create'
      preLoaderRoute: typeof dasboardOrdersOrdersCreateRouteImport
      parentRoute: typeof dasboardRouteRoute
    }
    '/(dasboard)/orders/orders/$id': {
      id: '/(dasboard)/orders/orders/$id'
      path: '/orders/orders/$id'
      fullPath: '/orders/orders/$id'
      preLoaderRoute: typeof dasboardOrdersOrdersIdRouteImport
      parentRoute: typeof dasboardRouteRoute
    }
    '/(dasboard)/inventory/supply-returns/create': {
      id: '/(dasboard)/inventory/supply-returns/create'
      path: '/inventory/supply-returns/create'
      fullPath: '/inventory/supply-returns/create'
      preLoaderRoute: typeof dasboardInventorySupplyReturnsCreateRouteImport
      parentRoute: typeof dasboardRouteRoute
    }
    '/(dasboard)/inventory/supply-returns/$id': {
      id: '/(dasboard)/inventory/supply-returns/$id'
      path: '/inventory/supply-returns/$id'
      fullPath: '/inventory/supply-returns/$id'
      preLoaderRoute: typeof dasboardInventorySupplyReturnsIdRouteImport
      parentRoute: typeof dasboardRouteRoute
    }
    '/(dasboard)/inventory/stock-transfers/create': {
      id: '/(dasboard)/inventory/stock-transfers/create'
      path: '/inventory/stock-transfers/create'
      fullPath: '/inventory/stock-transfers/create'
      preLoaderRoute: typeof dasboardInventoryStockTransfersCreateRouteImport
      parentRoute: typeof dasboardRouteRoute
    }
    '/(dasboard)/inventory/stock-batchs/create': {
      id: '/(dasboard)/inventory/stock-batchs/create'
      path: '/inventory/stock-batchs/create'
      fullPath: '/inventory/stock-batchs/create'
      preLoaderRoute: typeof dasboardInventoryStockBatchsCreateRouteImport
      parentRoute: typeof dasboardRouteRoute
    }
    '/(dasboard)/finance/debts/suppliers-debts': {
      id: '/(dasboard)/finance/debts/suppliers-debts'
      path: '/finance/debts/suppliers-debts'
      fullPath: '/finance/debts/suppliers-debts'
      preLoaderRoute: typeof dasboardFinanceDebtsSuppliersDebtsRouteImport
      parentRoute: typeof dasboardRouteRoute
    }
    '/(dasboard)/finance/debts/suppliers-credits': {
      id: '/(dasboard)/finance/debts/suppliers-credits'
      path: '/finance/debts/suppliers-credits'
      fullPath: '/finance/debts/suppliers-credits'
      preLoaderRoute: typeof dasboardFinanceDebtsSuppliersCreditsRouteImport
      parentRoute: typeof dasboardRouteRoute
    }
    '/(dasboard)/finance/debts/customers-debts': {
      id: '/(dasboard)/finance/debts/customers-debts'
      path: '/finance/debts/customers-debts'
      fullPath: '/finance/debts/customers-debts'
      preLoaderRoute: typeof dasboardFinanceDebtsCustomersDebtsRouteImport
      parentRoute: typeof dasboardRouteRoute
    }
    '/(dasboard)/finance/accounts/$id': {
      id: '/(dasboard)/finance/accounts/$id'
      path: '/finance/accounts/$id'
      fullPath: '/finance/accounts/$id'
      preLoaderRoute: typeof dasboardFinanceAccountsIdRouteImport
      parentRoute: typeof dasboardRouteRoute
    }
    '/(dasboard)/employees/$id/view': {
      id: '/(dasboard)/employees/$id/view'
      path: '/employees/$id/view'
      fullPath: '/employees/$id/view'
      preLoaderRoute: typeof dasboardEmployeesIdViewRouteImport
      parentRoute: typeof dasboardRouteRoute
    }
    '/(dasboard)/employees/$id/edit': {
      id: '/(dasboard)/employees/$id/edit'
      path: '/employees/$id/edit'
      fullPath: '/employees/$id/edit'
      preLoaderRoute: typeof dasboardEmployeesIdEditRouteImport
      parentRoute: typeof dasboardRouteRoute
    }
    '/(dasboard)/inventory/stock-batchs/$id/quantity-transfer-out': {
      id: '/(dasboard)/inventory/stock-batchs/$id/quantity-transfer-out'
      path: '/inventory/stock-batchs/$id/quantity-transfer-out'
      fullPath: '/inventory/stock-batchs/$id/quantity-transfer-out'
      preLoaderRoute: typeof dasboardInventoryStockBatchsIdQuantityTransferOutRouteImport
      parentRoute: typeof dasboardRouteRoute
    }
    '/(dasboard)/inventory/stock-batchs/$id/quantity-transfer-in': {
      id: '/(dasboard)/inventory/stock-batchs/$id/quantity-transfer-in'
      path: '/inventory/stock-batchs/$id/quantity-transfer-in'
      fullPath: '/inventory/stock-batchs/$id/quantity-transfer-in'
      preLoaderRoute: typeof dasboardInventoryStockBatchsIdQuantityTransferInRouteImport
      parentRoute: typeof dasboardRouteRoute
    }
    '/(dasboard)/inventory/stock-batchs/$id/quantity-supply-return': {
      id: '/(dasboard)/inventory/stock-batchs/$id/quantity-supply-return'
      path: '/inventory/stock-batchs/$id/quantity-supply-return'
      fullPath: '/inventory/stock-batchs/$id/quantity-supply-return'
      preLoaderRoute: typeof dasboardInventoryStockBatchsIdQuantitySupplyReturnRouteImport
      parentRoute: typeof dasboardRouteRoute
    }
    '/(dasboard)/inventory/stock-batchs/$id/quantity-sold': {
      id: '/(dasboard)/inventory/stock-batchs/$id/quantity-sold'
      path: '/inventory/stock-batchs/$id/quantity-sold'
      fullPath: '/inventory/stock-batchs/$id/quantity-sold'
      preLoaderRoute: typeof dasboardInventoryStockBatchsIdQuantitySoldRouteImport
      parentRoute: typeof dasboardRouteRoute
    }
    '/(dasboard)/inventory/stock-batchs/$id/quantity-sale-return': {
      id: '/(dasboard)/inventory/stock-batchs/$id/quantity-sale-return'
      path: '/inventory/stock-batchs/$id/quantity-sale-return'
      fullPath: '/inventory/stock-batchs/$id/quantity-sale-return'
      preLoaderRoute: typeof dasboardInventoryStockBatchsIdQuantitySaleReturnRouteImport
      parentRoute: typeof dasboardRouteRoute
    }
    '/(dasboard)/inventory/stock-batchs/$id/quantity-adjusted': {
      id: '/(dasboard)/inventory/stock-batchs/$id/quantity-adjusted'
      path: '/inventory/stock-batchs/$id/quantity-adjusted'
      fullPath: '/inventory/stock-batchs/$id/quantity-adjusted'
      preLoaderRoute: typeof dasboardInventoryStockBatchsIdQuantityAdjustedRouteImport
      parentRoute: typeof dasboardRouteRoute
    }
    '/(dasboard)/inventory/stock-batchs/$id/price-changes': {
      id: '/(dasboard)/inventory/stock-batchs/$id/price-changes'
      path: '/inventory/stock-batchs/$id/price-changes'
      fullPath: '/inventory/stock-batchs/$id/price-changes'
      preLoaderRoute: typeof dasboardInventoryStockBatchsIdPriceChangesRouteImport
      parentRoute: typeof dasboardRouteRoute
    }
  }
}

interface dasboardRouteRouteChildren {
  dasboardAuditLogsRoute: typeof dasboardAuditLogsRoute
  dasboardDashboardRoute: typeof dasboardDashboardRoute
  dasboardPosRoute: typeof dasboardPosRoute
  dasboardProfileRoute: typeof dasboardProfileRoute
  dasboardSettingsRoute: typeof dasboardSettingsRoute
  dasboardCustomersIdRoute: typeof dasboardCustomersIdRoute
  dasboardEmployeesCreateRoute: typeof dasboardEmployeesCreateRoute
  dasboardFinanceCategoriesRoute: typeof dasboardFinanceCategoriesRoute
  dasboardFinanceExpenseCategoriesRoute: typeof dasboardFinanceExpenseCategoriesRoute
  dasboardFinanceExpensesRoute: typeof dasboardFinanceExpensesRoute
  dasboardFinanceIncomeCategoriesRoute: typeof dasboardFinanceIncomeCategoriesRoute
  dasboardFinanceIncomesRoute: typeof dasboardFinanceIncomesRoute
  dasboardFinanceTransfersRoute: typeof dasboardFinanceTransfersRoute
  dasboardInventoryWarehousesRoute: typeof dasboardInventoryWarehousesRoute
  dasboardProductsCategoriesRoute: typeof dasboardProductsCategoriesRoute
  dasboardProductsSuppliersRoute: typeof dasboardProductsSuppliersRoute
  dasboardProductsTypesRoute: typeof dasboardProductsTypesRoute
  dasboardCustomersIndexRoute: typeof dasboardCustomersIndexRoute
  dasboardEmployeesIndexRoute: typeof dasboardEmployeesIndexRoute
  dasboardFinanceIndexRoute: typeof dasboardFinanceIndexRoute
  dasboardInventoryIndexRoute: typeof dasboardInventoryIndexRoute
  dasboardEmployeesIdEditRoute: typeof dasboardEmployeesIdEditRoute
  dasboardEmployeesIdViewRoute: typeof dasboardEmployeesIdViewRoute
  dasboardFinanceAccountsIdRoute: typeof dasboardFinanceAccountsIdRoute
  dasboardFinanceDebtsCustomersDebtsRoute: typeof dasboardFinanceDebtsCustomersDebtsRoute
  dasboardFinanceDebtsSuppliersCreditsRoute: typeof dasboardFinanceDebtsSuppliersCreditsRoute
  dasboardFinanceDebtsSuppliersDebtsRoute: typeof dasboardFinanceDebtsSuppliersDebtsRoute
  dasboardInventoryStockBatchsCreateRoute: typeof dasboardInventoryStockBatchsCreateRoute
  dasboardInventoryStockTransfersCreateRoute: typeof dasboardInventoryStockTransfersCreateRoute
  dasboardInventorySupplyReturnsIdRoute: typeof dasboardInventorySupplyReturnsIdRoute
  dasboardInventorySupplyReturnsCreateRoute: typeof dasboardInventorySupplyReturnsCreateRoute
  dasboardOrdersOrdersIdRoute: typeof dasboardOrdersOrdersIdRoute
  dasboardOrdersOrdersCreateRoute: typeof dasboardOrdersOrdersCreateRoute
  dasboardOrdersReturnsIdRoute: typeof dasboardOrdersReturnsIdRoute
  dasboardOrdersReturnsCreateRoute: typeof dasboardOrdersReturnsCreateRoute
  dasboardProductsProductsIdRoute: typeof dasboardProductsProductsIdRoute
  dasboardProductsProductsCreateRoute: typeof dasboardProductsProductsCreateRoute
  dasboardProductsServicesIdRoute: typeof dasboardProductsServicesIdRoute
  dasboardProductsServicesCreateRoute: typeof dasboardProductsServicesCreateRoute
  dasboardFinanceAccountsIndexRoute: typeof dasboardFinanceAccountsIndexRoute
  dasboardInventoryStockBatchsIndexRoute: typeof dasboardInventoryStockBatchsIndexRoute
  dasboardInventoryStockTransfersIndexRoute: typeof dasboardInventoryStockTransfersIndexRoute
  dasboardInventorySupplyReturnsIndexRoute: typeof dasboardInventorySupplyReturnsIndexRoute
  dasboardOrdersOrdersIndexRoute: typeof dasboardOrdersOrdersIndexRoute
  dasboardOrdersReturnsIndexRoute: typeof dasboardOrdersReturnsIndexRoute
  dasboardProductsProductsIndexRoute: typeof dasboardProductsProductsIndexRoute
  dasboardProductsServicesIndexRoute: typeof dasboardProductsServicesIndexRoute
  dasboardInventoryStockBatchsIdPriceChangesRoute: typeof dasboardInventoryStockBatchsIdPriceChangesRoute
  dasboardInventoryStockBatchsIdQuantityAdjustedRoute: typeof dasboardInventoryStockBatchsIdQuantityAdjustedRoute
  dasboardInventoryStockBatchsIdQuantitySaleReturnRoute: typeof dasboardInventoryStockBatchsIdQuantitySaleReturnRoute
  dasboardInventoryStockBatchsIdQuantitySoldRoute: typeof dasboardInventoryStockBatchsIdQuantitySoldRoute
  dasboardInventoryStockBatchsIdQuantitySupplyReturnRoute: typeof dasboardInventoryStockBatchsIdQuantitySupplyReturnRoute
  dasboardInventoryStockBatchsIdQuantityTransferInRoute: typeof dasboardInventoryStockBatchsIdQuantityTransferInRoute
  dasboardInventoryStockBatchsIdQuantityTransferOutRoute: typeof dasboardInventoryStockBatchsIdQuantityTransferOutRoute
}

const dasboardRouteRouteChildren: dasboardRouteRouteChildren = {
  dasboardAuditLogsRoute: dasboardAuditLogsRoute,
  dasboardDashboardRoute: dasboardDashboardRoute,
  dasboardPosRoute: dasboardPosRoute,
  dasboardProfileRoute: dasboardProfileRoute,
  dasboardSettingsRoute: dasboardSettingsRoute,
  dasboardCustomersIdRoute: dasboardCustomersIdRoute,
  dasboardEmployeesCreateRoute: dasboardEmployeesCreateRoute,
  dasboardFinanceCategoriesRoute: dasboardFinanceCategoriesRoute,
  dasboardFinanceExpenseCategoriesRoute: dasboardFinanceExpenseCategoriesRoute,
  dasboardFinanceExpensesRoute: dasboardFinanceExpensesRoute,
  dasboardFinanceIncomeCategoriesRoute: dasboardFinanceIncomeCategoriesRoute,
  dasboardFinanceIncomesRoute: dasboardFinanceIncomesRoute,
  dasboardFinanceTransfersRoute: dasboardFinanceTransfersRoute,
  dasboardInventoryWarehousesRoute: dasboardInventoryWarehousesRoute,
  dasboardProductsCategoriesRoute: dasboardProductsCategoriesRoute,
  dasboardProductsSuppliersRoute: dasboardProductsSuppliersRoute,
  dasboardProductsTypesRoute: dasboardProductsTypesRoute,
  dasboardCustomersIndexRoute: dasboardCustomersIndexRoute,
  dasboardEmployeesIndexRoute: dasboardEmployeesIndexRoute,
  dasboardFinanceIndexRoute: dasboardFinanceIndexRoute,
  dasboardInventoryIndexRoute: dasboardInventoryIndexRoute,
  dasboardEmployeesIdEditRoute: dasboardEmployeesIdEditRoute,
  dasboardEmployeesIdViewRoute: dasboardEmployeesIdViewRoute,
  dasboardFinanceAccountsIdRoute: dasboardFinanceAccountsIdRoute,
  dasboardFinanceDebtsCustomersDebtsRoute:
    dasboardFinanceDebtsCustomersDebtsRoute,
  dasboardFinanceDebtsSuppliersCreditsRoute:
    dasboardFinanceDebtsSuppliersCreditsRoute,
  dasboardFinanceDebtsSuppliersDebtsRoute:
    dasboardFinanceDebtsSuppliersDebtsRoute,
  dasboardInventoryStockBatchsCreateRoute:
    dasboardInventoryStockBatchsCreateRoute,
  dasboardInventoryStockTransfersCreateRoute:
    dasboardInventoryStockTransfersCreateRoute,
  dasboardInventorySupplyReturnsIdRoute: dasboardInventorySupplyReturnsIdRoute,
  dasboardInventorySupplyReturnsCreateRoute:
    dasboardInventorySupplyReturnsCreateRoute,
  dasboardOrdersOrdersIdRoute: dasboardOrdersOrdersIdRoute,
  dasboardOrdersOrdersCreateRoute: dasboardOrdersOrdersCreateRoute,
  dasboardOrdersReturnsIdRoute: dasboardOrdersReturnsIdRoute,
  dasboardOrdersReturnsCreateRoute: dasboardOrdersReturnsCreateRoute,
  dasboardProductsProductsIdRoute: dasboardProductsProductsIdRoute,
  dasboardProductsProductsCreateRoute: dasboardProductsProductsCreateRoute,
  dasboardProductsServicesIdRoute: dasboardProductsServicesIdRoute,
  dasboardProductsServicesCreateRoute: dasboardProductsServicesCreateRoute,
  dasboardFinanceAccountsIndexRoute: dasboardFinanceAccountsIndexRoute,
  dasboardInventoryStockBatchsIndexRoute:
    dasboardInventoryStockBatchsIndexRoute,
  dasboardInventoryStockTransfersIndexRoute:
    dasboardInventoryStockTransfersIndexRoute,
  dasboardInventorySupplyReturnsIndexRoute:
    dasboardInventorySupplyReturnsIndexRoute,
  dasboardOrdersOrdersIndexRoute: dasboardOrdersOrdersIndexRoute,
  dasboardOrdersReturnsIndexRoute: dasboardOrdersReturnsIndexRoute,
  dasboardProductsProductsIndexRoute: dasboardProductsProductsIndexRoute,
  dasboardProductsServicesIndexRoute: dasboardProductsServicesIndexRoute,
  dasboardInventoryStockBatchsIdPriceChangesRoute:
    dasboardInventoryStockBatchsIdPriceChangesRoute,
  dasboardInventoryStockBatchsIdQuantityAdjustedRoute:
    dasboardInventoryStockBatchsIdQuantityAdjustedRoute,
  dasboardInventoryStockBatchsIdQuantitySaleReturnRoute:
    dasboardInventoryStockBatchsIdQuantitySaleReturnRoute,
  dasboardInventoryStockBatchsIdQuantitySoldRoute:
    dasboardInventoryStockBatchsIdQuantitySoldRoute,
  dasboardInventoryStockBatchsIdQuantitySupplyReturnRoute:
    dasboardInventoryStockBatchsIdQuantitySupplyReturnRoute,
  dasboardInventoryStockBatchsIdQuantityTransferInRoute:
    dasboardInventoryStockBatchsIdQuantityTransferInRoute,
  dasboardInventoryStockBatchsIdQuantityTransferOutRoute:
    dasboardInventoryStockBatchsIdQuantityTransferOutRoute,
}

const dasboardRouteRouteWithChildren = dasboardRouteRoute._addFileChildren(
  dasboardRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  dasboardRouteRoute: dasboardRouteRouteWithChildren,
  onboardingAuthLoginRoute: onboardingAuthLoginRoute,
  onboardingAuthLogoutRoute: onboardingAuthLogoutRoute,
  onboardingAuthPasswordForgotRoute: onboardingAuthPasswordForgotRoute,
  onboardingAuthRegisterRoute: onboardingAuthRegisterRoute,
  onboardingAuthResetPasswordRoute: onboardingAuthResetPasswordRoute,
  onboardingAuthVerifyAccountRoute: onboardingAuthVerifyAccountRoute,
  onboardingAuthVerifyFailedRoute: onboardingAuthVerifyFailedRoute,
  onboardingAuthVerifySuccessRoute: onboardingAuthVerifySuccessRoute,
  onboardingSetupCreateBusinessRoute: onboardingSetupCreateBusinessRoute,
  onboardingSetupCreateShopRoute: onboardingSetupCreateShopRoute,
  onboardingSetupSelectShopRoute: onboardingSetupSelectShopRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
